const contentOutputs = {
  EDITABLE: 'editable',
  RENDERED: 'rendered',
  PLAIN_TEXT: 'plainText',
} as const;

export type ContentOutput =
  (typeof contentOutputs)[keyof typeof contentOutputs];
export default contentOutputs;
